import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TableRow } from '@material-ui/core';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { useUser } from '../../../../utils/hooks/auth';
import { DEFAULT_TABLE_ROW_HEIGHT, HoverLink, LoaderRow, TableCell, Typography } from '../../../../ui-kit';
import { localizeEnum } from '../../../../utils';
import { routePaths } from '../../../../routePaths';
import { DeductionReason } from '../../../../generated/graphql';
import { deductionListItemsHeadCells } from './constants';
import { DeductionListItems } from './types';

interface DeductionListItemsTableContentProps {
    deductionListItems: DeductionListItems;
    isLoading: boolean;
    rowsPerPage: number;
}

const DeductionListItemsTableContent = ({ deductionListItems, isLoading, rowsPerPage }: DeductionListItemsTableContentProps) => {
    const { t } = useTranslation();
    const { priceService } = usePriceService();
    const { user: { defaultCurrency } } = useUser();
    const history = useHistory();
    const referrer = history.location.pathname;

    return isLoading
        ? <LoaderRow columnCount={deductionListItemsHeadCells.length} itemsPerPage={rowsPerPage} itemHeight={DEFAULT_TABLE_ROW_HEIGHT} />
        : (
            <>
                {deductionListItems.map(row => (
                    <TableRow tabIndex={-1} key={row.id}>
                        {deductionListItemsHeadCells.map((cell, index) => {
                        let cellValue: React.ReactNode;
                        if (cell.id === 'stockCard') {
                            const stockCard = `${routePaths.warehouseCards}/${row.stockCard.id}`;

                            cellValue = (
                                <HoverLink wide to={{ pathname: stockCard, state: { referrer } }}>
                                    {row[cell.id].name}
                                </HoverLink>
                            );
                         } else if (cell.id === 'unitType') {
                            cellValue = localizeEnum(t)(row[cell.id], { DeductionReason });
                        } else if (cell.id === 'priceWithoutVat') {
                            cellValue = priceService.toLocaleString(row[cell.id], defaultCurrency.currencyCode);
                        } else {
                            cellValue = row[cell.id];
                        }
                        return (
                            <TableCell align={cell.align} isSticky={index === 0} key={`${cell.id} - ${row.id}`}>
                                <Typography variant='body2'>{cellValue}</Typography>
                            </TableCell>
                        );
                    })}
                    </TableRow>
                ))}
            </>
        );
};

export default DeductionListItemsTableContent;